module.exports = __webpack_public_path__ + "public/img/jiaoban.e3987376.png";